export function updatePTagsAndReturnHTML(node, classesToAdd = ['m-0', 'p-0']) {
  // Get all <p> elements within the provided node
  const pElements = node.querySelectorAll('p');

  // Iterate through each <p> element and add specified classes
  pElements.forEach((p) => {
    classesToAdd.forEach((className) => {
      p.classList.add(className);
    });
  });

  // Return the updated innerHTML of the node
  return node.innerHTML;
}
